import { render, staticRenderFns } from "./PurchasesStatistics.vue?vue&type=template&id=c2f864a0&"
import script from "./PurchasesStatistics.vue?vue&type=script&lang=js&"
export * from "./PurchasesStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports